import * as React from 'react';

const SvgSliderDotIndicator = (props) => (
  <svg
    width={40}
    height={40}
    fill='#fff'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <circle
      r={18}
      cx={20}
      cy={20}
      fill='none'
      stroke='#fff'
      strokeWidth={2}
      strokeDashoffset={113}
      strokeDasharray={113}
    />
  </svg>
);

export default SvgSliderDotIndicator;
